import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

export const infiniteScrollStyle = (isLoading = false): CSSProperties => ({
  height: isLoading ? '100%' : 'auto',
  overflow: isLoading ? 'hidden' : 'initial',
  position: 'relative',
  paddingBottom: 60,
});

interface StyledDivProps {
  children?: ReactNode;
  style?: any;
  name?: string;
  src?: string;
  ref?: any;
  onClick?: any;
}

export const TableWrapper = styled.div<StyledDivProps>``;

export const TableBody = styled.div<StyledDivProps>``;

export const NoRecordsFound = styled.p<StyledDivProps>`
  padding: 30px;
  margin: auto;
  text-align: center;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
`;

export const Centered = styled.div<StyledDivProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const iconStyle = {
  width: 25,
  height: 25,
};
